import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';
import { HiddenTourStep } from 'webapp/models-custom/tour/designer/option-hidden';

export default class DesignerAddToReportTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__ADD_TO_REPORT;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLES_DESIGNER_ADD_TO_REPORT;

	get id(): string {
		return TourId.DESIGNER__ADD_TO_REPORT;
	}

	override get keyForPersistantDone(): string {
		return DesignerAddToReportTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.LEFT,
				allowStacked: true,
				attachTo: () => {
					return $('#boardSettings .add-to-report');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override end(): void {
		super.end();
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.BOARD_OPTIONS_HIDDEN,
		);
	}
}
